(function () {
  var APP_URL = "https://carta-docente.vercel.app";
  var WORKER_URL = "https://bug.zerkraptor.workers.dev/";

  var shop = (window.Shopify && window.Shopify.shop) || "";
  if (!shop) return;

  var isProduct = window.location.pathname.indexOf("/products/") !== -1;

  /* ── Product-page variables ── */
  var dataEl = isProduct ? document.getElementById("bd-prod-data") : null;
  var productId     = dataEl ? dataEl.dataset.productId  || "" : "";
  var price         = dataEl ? parseFloat(dataEl.dataset.price) || 0 : 0;
  var logoUrl       = dataEl ? dataEl.dataset.logoUrl    || "" : "";
  var btnImgUrl     = dataEl ? dataEl.dataset.btnImgUrl  || "" : "";
  var customerEmail = dataEl ? dataEl.dataset.customerEmail || "" : "";
  var customerName  = dataEl ? dataEl.dataset.customerName  || "" : "";
  var customerPhone = dataEl ? dataEl.dataset.customerPhone || "" : "";
  var productTitle  = dataEl ? dataEl.dataset.productTitle  || "" : "";
  var suRichiesta   = dataEl ? dataEl.dataset.suRichiesta === "true" : false;
  var cdSospeso     = dataEl ? dataEl.dataset.cdSospeso   === "true" : false;

  /* ── Icone SVG inline ── */
  var SVG_SHIELD =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20" fill="#003D9A">' +
    '<path d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.2 38.3 31 38.3 57.2c0 160.7-98 240.9-207.5 282.7' +
    'c-6 2.3-12.6 2.3-18.6 0C159.9 380.9 16 300.7 16 140c0-26.2 16.3-48 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"/>' +
    '</svg>';

  var SVG_LOCK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="13" height="13" fill="currentColor">' +
    '<path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0' +
    's144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256' +
    'c0-35.3 28.7-64 64-64H80z"/></svg>';

  var SVG_CLOCK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" fill="currentColor">' +
    '<path d="M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 19.9l96 64' +
    'c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/>' +
    '</svg>';

  var SVG_LOCK_SM =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="11" height="11" fill="#9ca3af" style="flex-shrink:0">' +
    '<path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0' +
    's144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256' +
    'c0-35.3 28.7-64 64-64H80z"/></svg>';

  var SVG_WARN =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14" height="14" fill="#d97706" style="flex-shrink:0;margin-top:1px">' +
    '<path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40' +
    'c-14.3 0-27.6-7.5-34.7-19.8s-7.1-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128' +
    'c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224' +
    'a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"/></svg>';

  var SVG_CHECK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14" height="14" fill="currentColor">' +
    '<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0' +
    'l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>' +
    '</svg>';

  var SVG_WARN_LG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="48" height="48" fill="#d97706" style="display:block;margin:0 auto 14px">' +
    '<path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40' +
    'c-14.3 0-27.6-7.5-34.7-19.8s-7.1-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128' +
    'c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224' +
    'a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"/></svg>';

  var SVG_REPORT =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" fill="currentColor" style="flex-shrink:0">' +
    '<path d="M256 0c53 0 96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4' +
    'l0-3.6c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1' +
    'c14.2-7.3 30.4-11.4 47.5-11.4l112 0c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64' +
    'c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5' +
    'l64.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8' +
    'l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-56.6 35.2-91.9 35.9' +
    'L288 320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 167.7c-35.3-.8-67.4-14.1-91.9-35.9L68.9 515' +
    'c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C83.5 379.8 78 356.6 78 332' +
    'l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64.9 0c1.1-14.2 4.9-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9' +
    'l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"/></svg>';

  /* ── HTML step indicators ── */
  var STEPS_1 =
    '<div class="bd-steps">' +
      '<div class="bd-step active"><div class="bd-step-num">1</div><span>Codice voucher</span></div>' +
      '<div class="bd-step-sep"></div>' +
      '<div class="bd-step"><div class="bd-step-num">2</div><span>Conferma</span></div>' +
    '</div>';

  var STEPS_2 =
    '<div class="bd-steps">' +
      '<div class="bd-step done"><div class="bd-step-num">&#10003;</div><span>Verificato</span></div>' +
      '<div class="bd-step-sep" style="background:#16a34a;"></div>' +
      '<div class="bd-step active"><div class="bd-step-num">2</div><span>Conferma</span></div>' +
    '</div>';

  /* ── Stili (product page only) ── */
  if (dataEl) {
    var style = document.createElement("style");
    style.textContent =
      /* overlay */
      "#bd-overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);display:flex;align-items:center;" +
      "justify-content:center;z-index:2147483647;padding:16px;box-sizing:border-box;backdrop-filter:blur(3px);}" +
      /* modal */
      "#bd-modal{background:#fff;border-radius:14px;width:100%;max-width:460px;" +
      "box-shadow:0 24px 64px rgba(0,0,0,.22);position:relative;" +
      "font-family:'Open Sans',system-ui,sans-serif;overflow:hidden;border-top:4px solid #003D9A;}" +
      /* header */
      "#bd-modal-header{padding:16px 52px 16px 52px;border-bottom:1px solid #eef0f3;" +
      "display:flex;align-items:center;justify-content:center;}" +
      "#bd-modal-header img{height:44px;width:auto;display:block;}" +
      /* close */
      "#bd-close{position:absolute;top:13px;right:14px;background:none;border:none;font-size:1.4rem;" +
      "cursor:pointer;color:#9ca3af;line-height:1;padding:4px;transition:color .1s,background .1s;" +
      "border-radius:50%;width:32px;height:32px;display:flex;align-items:center;justify-content:center;}" +
      "#bd-close:hover{color:#0d1f3c;background:#f5f5f5;}" +
      /* body */
      "#bd-modal-body{padding:22px 24px 20px;}" +
      /* step indicator */
      ".bd-steps{display:flex;align-items:center;margin-bottom:20px;}" +
      ".bd-step{display:flex;align-items:center;gap:6px;font-size:.6875rem;font-weight:700;" +
      "color:#9ca3af;letter-spacing:.01em;text-transform:uppercase;white-space:nowrap;}" +
      ".bd-step.active{color:#003D9A;}" +
      ".bd-step.done{color:#16a34a;}" +
      ".bd-step-num{width:22px;height:22px;border-radius:50%;background:#e5e7eb;color:#6b7280;" +
      "font-size:.625rem;font-weight:800;display:flex;align-items:center;justify-content:center;" +
      "flex-shrink:0;line-height:1;}" +
      ".bd-step.active .bd-step-num{background:#003D9A;color:#fff;}" +
      ".bd-step.done .bd-step-num{background:#16a34a;color:#fff;font-size:.75rem;}" +
      ".bd-step-sep{flex:1;height:2px;background:#e5e7eb;margin:0 8px;border-radius:1px;min-width:16px;}" +
      /* text */
      "#bd-modal p{color:#4b5563;font-size:.875rem;margin:0 0 16px;line-height:1.6;font-family:'Open Sans',sans-serif;}" +
      /* label */
      ".bd-label{display:block;font-size:.6875rem;font-weight:700;color:#0d1f3c;" +
      "margin-bottom:8px;letter-spacing:.06em;text-transform:uppercase;}" +
      /* input */
      "#bd-input{width:100%;padding:12px 16px;border:1.5px solid #d1d5db;border-radius:8px;" +
      "font-size:1rem;font-family:'Courier New',Menlo,monospace;letter-spacing:.14em;" +
      "outline:none;box-sizing:border-box;transition:border-color .15s,box-shadow .15s;" +
      "color:#0d1f3c;background:#f9fafb;}" +
      "#bd-input:focus{border-color:#003D9A;background:#fff;box-shadow:0 0 0 3px rgba(0,61,154,.1);}" +
      "#bd-input::placeholder{color:#aaa;font-family:'Open Sans',sans-serif;" +
      "letter-spacing:0;text-transform:none;font-size:.875rem;}" +
      /* buttons */
      "#bd-submit,#bd-confirm-btn,#bd-final-btn,#bd-login-btn{display:flex;align-items:center;justify-content:center;" +
      "gap:8px;width:100%;padding:0 24px;margin-top:16px;background:#003D9A;color:#fff;border:none;" +
      "border-radius:9999px;cursor:pointer;font-size:.875rem;font-weight:700;letter-spacing:.04em;" +
      "text-transform:uppercase;font-family:'Open Sans',system-ui,sans-serif;min-height:46px;" +
      "box-sizing:border-box;transition:background .15s,transform .1s;text-decoration:none;}" +
      "#bd-submit:hover,#bd-confirm-btn:hover,#bd-final-btn:hover,#bd-login-btn:hover{background:#002d73;transform:translateY(-1px);}" +
      "#bd-submit:active,#bd-confirm-btn:active,#bd-final-btn:active{transform:translateY(0);}" +
      "#bd-submit:disabled,#bd-confirm-btn:disabled,#bd-final-btn:disabled{opacity:.4;cursor:default;transform:none;}" +
      /* report problem button (grigio, in linea col sito) */
      "#bd-report-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;" +
      "padding:0 18px;margin-top:10px;background:#f3f4f6;color:#4b5563;" +
      "border:1.5px solid #e5e7eb;border-radius:8px;cursor:pointer;" +
      "font-size:.8125rem;font-weight:600;letter-spacing:.04em;text-transform:uppercase;" +
      "font-family:'Open Sans',system-ui,sans-serif;min-height:44px;box-sizing:border-box;" +
      "transition:background .15s,border-color .15s,color .15s,transform .1s;text-align:center;line-height:1.25;}" +
      "#bd-report-btn:hover{background:#eef2f8;border-color:#003D9A;color:#003D9A;transform:translateY(-1px);}" +
      "#bd-report-btn:active{transform:translateY(0);}" +
      "#bd-report-btn:disabled{opacity:.55;cursor:default;transform:none;}" +
      /* cancel */
      "#bd-cancel-link{display:block;width:100%;text-align:center;margin-top:12px;color:#9ca3af;" +
      "font-size:.8125rem;cursor:pointer;text-decoration:none;background:none;border:none;" +
      "font-family:'Open Sans',sans-serif;padding:4px 0;transition:color .1s;}" +
      "#bd-cancel-link:hover{color:#0d1f3c;}" +
      /* messages */
      "#bd-msg{margin-top:12px;padding:10px 14px;border-radius:8px;font-size:.85rem;display:none;" +
      "font-family:'Open Sans',sans-serif;}" +
      "#bd-msg.ok{background:#d1fae5;color:#065f46;display:block;}" +
      "#bd-msg.err{background:#fee2e2;color:#991b1b;display:block;}" +
      /* preview box step 2 */
      "#bd-preview-box{background:#fff;border:1.5px solid #bfdbfe;border-radius:10px;overflow:hidden;margin-bottom:16px;}" +
      ".bd-preview-header{background:linear-gradient(135deg,#eff6ff,#dbeafe);padding:13px 18px 12px;border-bottom:1px solid #bfdbfe;}" +
      ".bd-preview-name{font-size:.9375rem;font-weight:700;color:#1e3a6e;line-height:1.25;text-transform:capitalize;}" +
      ".bd-preview-cf{font-size:.6875rem;color:#9ca3af;font-family:'Courier New',monospace;letter-spacing:.06em;margin-top:3px;}" +
      ".bd-preview-body{padding:12px 18px 6px;}" +
      ".bd-preview-row{display:flex;align-items:baseline;gap:8px;margin:0 0 8px;}" +
      ".bd-preview-key{font-size:.625rem;font-weight:800;text-transform:uppercase;letter-spacing:.08em;" +
      "color:#6b7280;min-width:52px;flex-shrink:0;}" +
      ".bd-preview-val{font-size:.8125rem;color:#374151;font-weight:500;line-height:1.35;}" +
      ".bd-preview-footer{display:flex;align-items:center;justify-content:space-between;padding:12px 18px;" +
      "background:linear-gradient(90deg,#dbeafe,#e0f2fe);border-top:1px solid #bfdbfe;}" +
      ".bd-preview-footer-label{font-size:.6875rem;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#3b82f6;}" +
      "#bd-preview-amount{font-size:1.5rem;font-weight:800;color:#003D9A;letter-spacing:-.01em;}" +
      /* notice */
      ".bd-notice{display:flex;align-items:flex-start;gap:10px;background:#fffbeb;" +
      "border-left:3px solid #f59e0b;border-radius:0 6px 6px 0;padding:10px 14px;margin-bottom:16px;" +
      "font-size:.8rem;color:#78350f;line-height:1.5;font-family:'Open Sans',sans-serif;}" +
      /* trust footer */
      ".bd-trust{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:18px;" +
      "padding-top:14px;border-top:1px solid #f3f4f6;font-size:.6875rem;color:#9ca3af;}" +
      /* termini e condizioni (step 2) */
      ".bd-terms{background:#fff7ed;border:1px solid #fed7aa;border-radius:8px;padding:12px 16px;margin-bottom:16px;}" +
      ".bd-terms-title{display:flex;align-items:center;gap:6px;font-size:.8125rem;font-weight:700;color:#92400e;margin-bottom:8px;}" +
      ".bd-terms-list{margin:0 0 8px;padding-left:18px;}" +
      ".bd-terms-list li{font-size:.75rem;color:#78350f;line-height:1.55;margin-bottom:3px;}" +
      ".bd-terms-link{font-size:.75rem;color:#2563eb;text-decoration:underline;}" +
      /* step 3 — conferma definitiva */
      ".bd-final-warning{text-align:center;padding:4px 0 18px;}" +
      ".bd-final-warning h3{font-size:1rem;font-weight:700;color:#0d1f3c;margin:0 0 8px;}" +
      ".bd-final-warning p{font-size:.875rem;color:#4b5563;margin:0;line-height:1.6;}" +
      ".bd-checkbox-label{display:flex;align-items:flex-start;gap:10px;background:#f9fafb;" +
      "border:1.5px solid #e5e7eb;border-radius:8px;padding:12px 14px;margin-bottom:4px;cursor:pointer;" +
      "transition:border-color .15s;}" +
      ".bd-checkbox-label:hover{border-color:#003D9A;}" +
      ".bd-checkbox-label input[type=checkbox]{flex-shrink:0;margin-top:2px;width:16px;height:16px;" +
      "accent-color:#003D9A;cursor:pointer;}" +
      ".bd-checkbox-label span{font-size:.8125rem;color:#374151;line-height:1.5;user-select:none;}" +
      /* product page button */
      "#bd-btn-wrapper{margin-top:10px;}" +
      "#bd-carta-btn{display:flex;align-items:center;justify-content:center;width:100%;padding:6px 20px;" +
      "background:#fff;color:#003D9A;border:1.5px solid #d1d5db;border-radius:9999px;cursor:pointer;" +
      "min-height:var(--button-addtocart-desktop-height,40px);box-sizing:border-box;" +
      "transition:border-color .15s,box-shadow .15s;}" +
      "#bd-carta-btn:hover{border-color:#003D9A;box-shadow:0 0 0 2px rgba(0,61,154,.15);}" +
      "#bd-carta-btn img{height:28px;width:auto;max-width:100%;object-fit:contain;display:block;}";
    document.head.appendChild(style);
  }

  var prodPreviewId = null;
  var lastVoucherError = ""; // ultimo errore mostrato all'utente (verifica/riscatto)

  /* ── Aggiorna solo il testo di un pulsante con icona ── */
  function setBtnText(btn, text) {
    var span = btn.querySelector("span.bd-btn-text");
    if (span) span.textContent = text;
    else btn.textContent = text;
  }

  /* ── Controlla se un elemento è dentro un drawer/mini-cart ── */
  function isInDrawer(el) {
    var node = el;
    while (node && node !== document.body) {
      var id  = (node.id  || "").toLowerCase();
      var cls = (typeof node.className === "string" ? node.className : "").toLowerCase();
      if (
        id.includes("drawer") || id.includes("mini-cart") || id.includes("cart-popup") ||
        id.includes("cart-notification") || id.includes("side-cart") || id.includes("cart-sidebar") ||
        cls.includes("drawer") || cls.includes("mini-cart") || cls.includes("cart-popup") ||
        cls.includes("cart-notification") || cls.includes("side-cart") || cls.includes("cart-sidebar")
      ) return true;
      node = node.parentElement;
    }
    return false;
  }

  /* ── Trova il punto di inserimento nella pagina prodotto ── */
  function findInsertionPoint() {
    /* Ancora esplicita: pagine con form d'acquisto non standard (es. il selettore
       posti di Claude Team) la espongono per dire dove va il pulsante. Senza,
       l'euristica sotto rischia di agganciarsi a un form nascosto. */
    var anchor = document.querySelector("[data-bd-cd-anchor]");
    if (anchor) return anchor;

    var mainSelectors = [
      "#MainContent",
      "main",
      "[role='main']",
      "#shopify-section-main-product",
      "#shopify-section-product-template",
      ".main-content",
    ];
    var mainArea = null;
    for (var i = 0; i < mainSelectors.length; i++) {
      mainArea = document.querySelector(mainSelectors[i]);
      if (mainArea) break;
    }

    if (mainArea) {
      var payBtn = mainArea.querySelector("[data-shopify='payment-button'], .shopify-payment-button");
      if (payBtn) return payBtn;

      var form = mainArea.querySelector(
        "form[action='/cart/add'], form[action*='/cart/add'], form.product-form, form[id*='product-form'], form[id*='ProductForm']"
      );
      if (form) return form;
    }

    var allForms = Array.from(document.querySelectorAll("form[action*='/cart/add']"));
    for (var j = 0; j < allForms.length; j++) {
      if (!isInDrawer(allForms[j])) return allForms[j];
    }

    return null;
  }

  /* ── Verifica login cliente ── */
  function isLoggedIn() {
    if (customerEmail) return true;
    if (window.Shopify && window.Shopify.customer) return true;
    if (document.querySelector('a[href*="logout"], a[href*="account/logout"]')) return true;
    if (document.body.dataset.customerLoggedIn === "true") return true;
    return false;
  }

  /* ── Crea e inietta il pulsante accanto all'add-to-cart ── */
  function initProductBtn() {
    if (document.getElementById("bd-btn-wrapper")) return;

    var insertAfter = findInsertionPoint();
    if (!insertAfter) return;

    var wrapper = document.createElement("div");
    wrapper.id = "bd-btn-wrapper";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.id = "bd-carta-btn";

    if (btnImgUrl) {
      var img = document.createElement("img");
      img.src = btnImgUrl;
      img.alt = "Paga con Carta del Docente";
      img.onerror = function() {
        this.style.display = "none";
        var fb = document.createElement("span");
        fb.textContent = "Paga con Carta del Docente";
        btn.appendChild(fb);
      };
      btn.appendChild(img);
    } else {
      var label = document.createElement("span");
      label.textContent = "Paga con Carta del Docente";
      btn.appendChild(label);
    }

    wrapper.appendChild(btn);
    insertAfter.insertAdjacentElement("afterend", wrapper);

    btn.addEventListener("click", openProdModal);
  }

  /* ── Carta del Docente su richiesta di autorizzazione ── */
  function getCdAuthToken() {
    try { return new URLSearchParams(window.location.search).get("cd_auth") || ""; }
    catch (e) { return ""; }
  }

  function initRequestBtn() {
    if (document.getElementById("bd-btn-wrapper")) return;

    var insertAfter = findInsertionPoint();
    if (!insertAfter) return;

    var wrapper = document.createElement("div");
    wrapper.id = "bd-btn-wrapper";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.id = "bd-carta-btn";

    if (btnImgUrl) {
      var img = document.createElement("img");
      img.src = btnImgUrl;
      img.alt = "Paga con Carta del Docente";
      img.onerror = function() {
        this.style.display = "none";
        var fb = document.createElement("span");
        fb.textContent = "Paga con Carta del Docente";
        btn.appendChild(fb);
      };
      btn.appendChild(img);
    } else {
      var label = document.createElement("span");
      label.textContent = "Paga con Carta del Docente";
      btn.appendChild(label);
    }

    wrapper.appendChild(btn);
    insertAfter.insertAdjacentElement("afterend", wrapper);

    btn.addEventListener("click", function () {
      var ov = document.getElementById("cdr-overlay-" + productId);
      if (!ov) return;
      if (ov.parentElement !== document.body) document.body.appendChild(ov);
      ov.hidden = false;
    });
  }

  /* ── Maschera un indirizzo email: primo carattere + *** + @dominio ── */
  function maskEmail(email) {
    var parts = String(email || "").split("@");
    if (parts.length !== 2 || !parts[0]) return "il tuo account";
    return parts[0].charAt(0) + "***@" + parts[1];
  }

  /* ── Box informativo: token valido ma account non corrispondente ── */
  function initLoginNotice(tokenEmail) {
    if (document.getElementById("bd-btn-wrapper")) return;

    var insertAfter = findInsertionPoint();
    if (!insertAfter) return;

    var wrapper = document.createElement("div");
    wrapper.id = "bd-btn-wrapper";

    var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    var maskedEmail = maskEmail(tokenEmail);

    wrapper.innerHTML =
      '<div style="border:1px solid #e5e7eb;border-radius:12px;padding:16px;' +
      'font-family:\'Open Sans\',system-ui,sans-serif;background:#fff;box-sizing:border-box;' +
      'box-shadow:0 1px 3px rgba(0,0,0,.06);">' +
        '<div style="display:flex;align-items:center;gap:7px;color:#003D9A;font-size:.75rem;' +
        'font-weight:700;letter-spacing:.03em;text-transform:uppercase;margin-bottom:10px;">' +
          '<span style="display:flex;flex-shrink:0;">' + SVG_LOCK + '</span>' +
          '<span>Accesso richiesto</span>' +
        '</div>' +
        '<p style="margin:0;color:#4b5563;font-size:.8125rem;line-height:1.55;">' +
          'Questa autorizzazione &egrave; riservata a<br>' +
          '<b id="bd-login-acct" style="color:#111827;word-break:break-all;"></b>' +
        '</p>' +
        '<a href="/account/login?return_url=' + returnUrl + '" style="display:flex;align-items:center;' +
        'justify-content:center;width:100%;padding:0 14px;margin-top:14px;background:#003D9A;' +
        'color:#fff;border-radius:9999px;font-size:.8125rem;font-weight:700;' +
        'letter-spacing:.03em;text-transform:uppercase;font-family:\'Open Sans\',system-ui,sans-serif;' +
        'min-height:44px;box-sizing:border-box;text-decoration:none;white-space:nowrap;">Accedi</a>' +
      '</div>';

    insertAfter.insertAdjacentElement("afterend", wrapper);
    document.getElementById("bd-login-acct").textContent = maskedEmail;
  }

  /* ── Striscia informativa al posto del pulsante (sospensione o limite annuo) ──
     Compatta per scelta: una riga sottile con icona e una sola frase, inserita
     dopo il contenitore delle azioni a tutta larghezza (fuori dalla colonna
     stretta dei bottoni, che su desktop e' ~300px). */
  /* Messaggio di chiusura ordini CdD per l'a.s. 2025/26: la finestra
     hardware/software (D.M. 59 del 31/03/2026) si chiude il 31/08/2026. */
  var CD_SOSPESO_MSG =
    'Il pagamento con <b>Carta del Docente</b> non è più disponibile sul nostro sito ' +
    'per l’anno scolastico 2025/26: <b>non accettiamo più ordini con il bonus</b> per quest’anno. ' +
    'Il tuo credito resta spendibile presso le altre piattaforme aderenti.';

  function initSospesoNotice(testoHtml, opts) {
    if (document.getElementById("bd-btn-wrapper")) return;

    var insertAfter = findInsertionPoint();
    if (!insertAfter) return;

    var container =
      insertAfter.closest(".prd-block-actions") ||
      insertAfter.closest("form[action*='/cart/add'], form.js-product-form") ||
      insertAfter;

    var wrapper = document.createElement("div");
    wrapper.id = "bd-btn-wrapper";

    var avvisami = opts && opts.avvisami;

    wrapper.innerHTML =
      '<div style="display:flex;flex-wrap:wrap;align-items:center;gap:8px 9px;width:100%;' +
      'border:1px solid #fde68a;border-radius:8px;padding:8px 14px;' +
      'font-family:\'Open Sans\',system-ui,sans-serif;background:#fffbeb;box-sizing:border-box;">' +
        '<span style="display:flex;flex-shrink:0;color:#b45309;">' + SVG_CLOCK + '</span>' +
        '<span style="color:#92400e;font-size:.8125rem;line-height:1.4;flex:1;min-width:200px;">' +
        (testoHtml ||
          'Pagamento con Carta del Docente <b>temporaneamente non disponibile</b>: il servizio verr&agrave; ripristinato il prima possibile.') +
        '</span>' +
        (opts && opts.regole ?
          '<button type="button" id="bd-regole-btn" style="flex-shrink:0;border:none;' +
          'background:#b45309;color:#fff;border-radius:9999px;padding:5px 14px;cursor:pointer;' +
          'font-family:inherit;font-size:.75rem;font-weight:700;letter-spacing:.02em;white-space:nowrap;">Come funziona</button>'
          : '') +
        (avvisami ?
          '<button type="button" id="bd-avvisami-btn" style="flex-shrink:0;border:1px solid #b45309;' +
          'background:transparent;color:#b45309;border-radius:9999px;padding:4px 14px;cursor:pointer;' +
          'font-family:inherit;font-size:.75rem;font-weight:700;letter-spacing:.02em;white-space:nowrap;">Avvisami</button>'
          : '') +
        (opts && opts.regole ?
          '<div style="flex-basis:100%;display:flex;flex-wrap:wrap;align-items:center;gap:6px 10px;' +
          'border-top:1px dashed #fde68a;padding-top:8px;margin-top:2px;">' +
            '<span style="color:#92400e;font-size:.8125rem;line-height:1.4;flex:1;min-width:180px;">' +
            'Non sei d’accordo con il <b>vincolo dei 4 anni</b> su PC, tablet e software?</span>' +
            '<a href="https://c.org/fTKMgz4rTX" ' +
            'target="_blank" rel="noopener" style="flex-shrink:0;display:inline-block;background:#dc2626;color:#fff;' +
            'border-radius:9999px;padding:5px 16px;text-decoration:none;font-family:inherit;font-size:.75rem;' +
            'font-weight:700;letter-spacing:.02em;white-space:nowrap;">&#9997;&#65039; Firma la petizione</a>' +
          '</div>'
          : '') +
      '</div>';

    container.insertAdjacentElement("afterend", wrapper);

    if (avvisami) initAvvisami(wrapper);
    if (opts && opts.regole) {
      var regoleBtn = wrapper.querySelector("#bd-regole-btn");
      if (regoleBtn) regoleBtn.addEventListener("click", showRegoleModal);
    }
  }

  /* ── Popup regole Carta del Docente 2025/26 ── */
  function showRegoleModal() {
    var existing = document.getElementById("bd-regole-overlay");
    if (existing) { existing.style.display = "flex"; return; }

    var H_STYLE = "font-family:'Montserrat',sans-serif;font-size:12px;font-weight:700;" +
      "letter-spacing:.4px;text-transform:uppercase;color:#13121d;margin:18px 0 6px;";
    var P_STYLE = "font-size:13.5px;line-height:1.6;color:#6b7280;margin:0 0 8px;";
    var B_OPEN = '<b style="color:#13121d;font-weight:600;">';

    var overlay = document.createElement("div");
    overlay.id = "bd-regole-overlay";
    overlay.style.cssText =
      "position:fixed;inset:0;z-index:100000;background:rgba(19,18,29,.62);" +
      "-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);" +
      "display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;";

    overlay.innerHTML =
      '<div role="dialog" aria-modal="true" aria-label="Regole Carta del Docente 2025/26" ' +
      'style="background:#fff;border-radius:16px;max-width:600px;width:100%;max-height:85vh;overflow-y:auto;' +
      'padding:28px 26px;box-sizing:border-box;box-shadow:0 20px 60px rgba(0,0,0,.25);' +
      "font-family:'Open Sans',system-ui,sans-serif;\">" +

        '<p style="font-family:\'Montserrat\',sans-serif;font-size:15px;font-weight:700;letter-spacing:.4px;' +
        'text-transform:uppercase;color:#13121d;margin:0 0 4px;line-height:1.35;">' +
        'Carta del Docente — le regole per il 2025/26</p>' +
        '<p style="' + P_STYLE + '">Riferimento: decreto ministeriale n.&nbsp;59 del 31 marzo 2026.</p>' +

        '<p style="' + H_STYLE + '">Perché non accettiamo più ordini</p>' +
        '<p style="' + P_STYLE + '">La finestra per acquistare ' + B_OPEN + 'software e hardware</b> con la Carta del Docente ' +
        'si chiude il ' + B_OPEN + '31 agosto 2026</b>. A ridosso della scadenza non possiamo più garantire ' +
        'la convalida dei buoni e l’evasione degli ordini in tempo utile: per questo sul nostro sito ' +
        B_OPEN + 'non accettiamo più ordini con Carta del Docente per l’anno scolastico 2025/26</b>. ' +
        'Il tuo credito resta comunque spendibile presso le altre piattaforme e gli altri esercenti aderenti, ' +
        'nelle categorie consentite.</p>' +

        '<p style="' + H_STYLE + '">Le date da ricordare</p>' +
        '<p style="' + P_STYLE + '">• ' + B_OPEN + '31 agosto 2026</b>: scade il residuo dell’a.s. 2024/25 ' +
        '(gli importi non spesi vanno persi) e si chiude la finestra per software e hardware.<br>' +
        '• Il bonus dell’a.s. 2025/26 (' + B_OPEN + '383 €</b>, esteso da quest’anno anche ai supplenti) ' +
        'resta valido fino al ' + B_OPEN + '31 agosto 2027</b>, ma solo per le altre categorie di spesa: ' +
        'libri, corsi di formazione, eventi culturali e simili — non per software o hardware.</p>' +

        '<p style="' + H_STYLE + '">La regola dei 4 anni</p>' +
        '<p style="' + P_STYLE + '">Dal 2025/26 software e hardware si possono acquistare con la Carta solo ' +
        'in occasione della ' + B_OPEN + 'prima erogazione</b> e poi con ' + B_OPEN + 'cadenza quadriennale</b>. ' +
        'Per tutti i docenti che avevano già la Carta, il 2025/26 è la prima finestra utile: chi non completa ' +
        'l’acquisto entro il ' + B_OPEN + '31 agosto 2026</b> non potrà più usare la Carta per software o hardware ' +
        'fino all’a.s. ' + B_OPEN + '2029/30</b>, indipendentemente dal credito residuo o dai buoni già generati. ' +
        'Fanno eccezione solo i neodocenti, la cui finestra si aprirà con la loro prima erogazione della Carta.</p>' +

        '<p style="' + H_STYLE + '">Attenzione ai buoni generati</p>' +
        '<p style="' + P_STYLE + '">Un buono generato ma ' + B_OPEN + 'non convalidato dall’esercente</b> non è credito speso: ' +
        'se scade senza essere stato convalidato, l’importo rischia di andare perso.</p>' +

        '<div style="text-align:center;margin-top:18px;">' +
        '<button type="button" id="bd-regole-close" style="border:none;border-radius:10px;cursor:pointer;' +
        'background:#e75a12;color:#fff;padding:11px 30px;font-family:\'Montserrat\',sans-serif;' +
        'font-size:12px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;">Ho capito</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) overlay.style.display = "none";
    });
    overlay.querySelector("#bd-regole-close").addEventListener("click", function () {
      overlay.style.display = "none";
    });
  }

  /* ── "Avvisami quando torna disponibile": iscrive all'email marketing Shopify
     (tag cd-avvisami) tramite l'app. Se il cliente e' loggato basta un click;
     altrimenti il pulsante lascia il posto a un campo email inline. ── */
  function initAvvisami(wrapper) {
    var btn = wrapper.querySelector("#bd-avvisami-btn");
    if (!btn) return;
    var box = btn.parentElement;

    function esito(ok, msg) {
      var el = document.createElement("span");
      el.style.cssText = "flex-shrink:0;font-size:.75rem;font-weight:700;color:" + (ok ? "#15803d" : "#b91c1c") + ";";
      el.textContent = msg;
      box.appendChild(el);
      if (!ok) setTimeout(function () { el.remove(); mostraForm(); }, 4000);
    }

    function invia(email, elDaRimuovere) {
      elDaRimuovere.forEach(function (el) { el.disabled = true; });
      fetch(APP_URL + "/api/cd-notify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shop: shop, email: email }),
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          elDaRimuovere.forEach(function (el) { el.remove(); });
          if (d && d.ok) esito(true, "\u2713 Ti avviseremo via email");
          else esito(false, (d && d.error) || "Errore, riprova.");
        })
        .catch(function () {
          elDaRimuovere.forEach(function (el) { el.remove(); });
          esito(false, "Errore di rete, riprova.");
        });
    }

    function mostraForm() {
      var input = document.createElement("input");
      input.type = "email";
      input.placeholder = "La tua email";
      input.style.cssText = "flex:1;min-width:150px;max-width:220px;border:1px solid #d6d3d1;" +
        "border-radius:9999px;padding:4px 12px;font-family:inherit;font-size:.75rem;outline:none;background:#fff;";
      var ok = document.createElement("button");
      ok.type = "button";
      ok.textContent = "Invia";
      ok.style.cssText = "flex-shrink:0;border:none;background:#b45309;color:#fff;border-radius:9999px;" +
        "padding:5px 14px;cursor:pointer;font-family:inherit;font-size:.75rem;font-weight:700;";
      box.appendChild(input);
      box.appendChild(ok);
      input.focus();
      function submit() {
        var v = (input.value || "").trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { input.style.borderColor = "#b91c1c"; return; }
        invia(v, [input, ok]);
      }
      ok.addEventListener("click", submit);
      input.addEventListener("keydown", function (e) { if (e.key === "Enter") submit(); });
    }

    btn.addEventListener("click", function () {
      if (customerEmail) { invia(customerEmail, [btn]); return; }
      btn.remove();
      mostraForm();
    });
  }

  /* ── Variante attualmente selezionata dal cliente ──
     Va letta dal form d'acquisto reale del tema (form.js-product-form): la
     pagina contiene altri form /cart/add nascosti (i quick-add del dropdown
     "disponibilità", uno per variante) che precedono quello vero nel DOM e
     restano fissi sulla prima variante. */
  function getSelectedVariantId() {
    var el =
      document.querySelector(".shopify-section.product-section form.js-product-form [name='id']") ||
      document.querySelector("form.js-product-form [name='id']");
    if (el && el.value) return el.value;

    var urlVariant = "";
    try { urlVariant = new URLSearchParams(window.location.search).get("variant") || ""; } catch (e) {}
    if (urlVariant) return urlVariant;

    el =
      document.querySelector("form[action*='/cart/add'] [name='id']") ||
      document.querySelector("select[name='id'], input[name='id']");
    if (el && el.value) return el.value;

    return dataEl.dataset.variantId || "";
  }

  /* ── Costruisce il wrapper modal ── */
  function buildOverlay(bodyHtml) {
    var overlay = document.createElement("div");
    overlay.id = "bd-overlay";
    overlay.innerHTML =
      '<div id="bd-modal">' +
        '<div id="bd-modal-header">' +
          (logoUrl
            ? '<img src="' + logoUrl + '" alt="Carta del Docente" onerror="this.style.display=\'none\'">'
            : SVG_SHIELD) +
          '<button id="bd-close" aria-label="Chiudi">&times;</button>' +
        '</div>' +
        '<div id="bd-modal-body">' + bodyHtml + '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.getElementById("bd-close").addEventListener("click", closeProdModal);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) closeProdModal(); });
    return overlay;
  }

  /* ── Modal step 1: inserimento voucher ── */
  function openProdModal() {
    if (document.getElementById("bd-overlay")) return;
    prodPreviewId = null;

    if (!isLoggedIn()) {
      var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      buildOverlay(
        '<p>Per utilizzare il buono Carta del Docente devi accedere al tuo account. Dopo il login tornerai automaticamente su questa pagina.</p>' +
        '<a id="bd-login-btn" href="/account/login?return_url=' + returnUrl + '">' + SVG_LOCK + '<span class="bd-btn-text">Accedi al tuo account</span></a>' +
        '<button id="bd-cancel-link" type="button">Annulla</button>'
      );
      document.getElementById("bd-cancel-link").addEventListener("click", closeProdModal);
      return;
    }

    var variantId = getSelectedVariantId();

    buildOverlay(
      STEPS_1 +
      '<div class="bd-notice">' + SVG_WARN +
        '<span><strong>Un solo voucher per ordine.</strong> Per acquistare altri prodotti idonei, effettua ordini separati.</span>' +
      '</div>' +
      '<label class="bd-label" for="bd-input">Codice buono</label>' +
      '<input id="bd-input" type="text" placeholder="Es. ABCD1234EFGH" maxlength="16" autocomplete="off" />' +
      '<button id="bd-submit" type="button">' + SVG_LOCK + '<span class="bd-btn-text">Verifica voucher</span></button>' +
      '<button id="bd-report-btn" type="button">' + SVG_REPORT + '<span class="bd-btn-text">Hai problemi con il tuo voucher? Segnalalo subito</span></button>' +
      '<div id="bd-msg"></div>' +
      '<div class="bd-trust">' + SVG_LOCK_SM + '<span>Transazione sicura &middot; certificata MIUR</span></div>'
    );

    document.getElementById("bd-submit").addEventListener("click", function () { submitStep1(variantId); });
    document.getElementById("bd-report-btn").addEventListener("click", sendReport);
    document.getElementById("bd-input").addEventListener("keydown", function (e) { if (e.key === "Enter") submitStep1(variantId); });
    document.getElementById("bd-input").focus();
  }

  function closeProdModal() {
    var o = document.getElementById("bd-overlay");
    if (o) o.remove();
  }

  /* ── Step 1: verifica voucher (preview) ── */
  async function submitStep1(variantId) {
    var input = document.getElementById("bd-input");
    var code = input.value.trim();
    if (!code) { showMsg("Inserisci il codice voucher.", false); return; }
    var btn = document.getElementById("bd-submit");
    btn.disabled = true;
    setBtnText(btn, "Verifica in corso…");
    showMsg("", null);
    try {
      var cartItems = productId ? [{ productId: String(productId), price: price, quantity: 1 }] : [];
      var res = await fetch(APP_URL + "/api/preview-voucher", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ voucherCode: code, shop: shop, cartItems: cartItems, cdAuthToken: getCdAuthToken() || "" }),
      });
      var data = await res.json();
      if (data.valid) {
        prodPreviewId = data.previewId;
        showStep2(data, variantId);
      } else {
        showMsg(data.message || "Voucher non valido o già utilizzato.", false);
        btn.disabled = false;
        setBtnText(btn, "Verifica voucher");
      }
    } catch {
      showMsg("Errore di rete. Riprova.", false);
      btn.disabled = false;
      setBtnText(btn, "Verifica voucher");
    }
  }

  /* ── Segnalazione problema voucher (invio immediato all'amministratore) ── */
  async function sendReport() {
    var btn = document.getElementById("bd-report-btn");
    if (!btn || btn.disabled) return;
    var input = document.getElementById("bd-input");
    var code = input && input.value.trim() ? input.value.trim() : "";

    // Cattura l'errore attualmente mostrato (o l'ultimo registrato) prima di pulire il messaggio
    var msgEl = document.getElementById("bd-msg");
    var visibleErr = msgEl && msgEl.classList.contains("err") ? msgEl.textContent.trim() : "";
    var reportedError = visibleErr || lastVoucherError || "";

    btn.disabled = true;
    setBtnText(btn, "Invio segnalazione…");
    showMsg("", null);

    try {
      var res = await fetch(APP_URL + "/api/report-issue", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          shop: shop,
          customerName: customerName,
          customerEmail: customerEmail,
          customerPhone: customerPhone,
          voucherCode: code,
          productTitle: productTitle,
          pageUrl: window.location.href,
          errorReason: reportedError,
        }),
      });
      var data = await res.json().catch(function () { return {}; });
      if (res.ok && data.ok !== false) {
        setBtnText(btn, "Segnalazione inviata ✓");
        showMsg("Abbiamo ricevuto la tua segnalazione. Ti contatteremo al più presto.", true);
      } else {
        btn.disabled = false;
        setBtnText(btn, "Hai problemi con il tuo voucher? Segnalalo subito");
        showMsg("Impossibile inviare la segnalazione. Riprova o contattaci.", false);
      }
    } catch {
      btn.disabled = false;
      setBtnText(btn, "Hai problemi con il tuo voucher? Segnalalo subito");
      showMsg("Errore di rete. Riprova.", false);
    }
  }

  /* ── Step 2: anteprima e conferma ── */
  function showStep2(previewData, variantId) {
    var modalBody = document.getElementById("bd-modal-body");
    if (!modalBody) return;

    var nominativo = previewData.nominativoDocente || "Docente";
    var amount = Number(previewData.eligibleAmount || 0).toFixed(2);

    /* Separa codice fiscale dal nome (es. "RMOMME74L46G273E - EMMA ROMEO") */
    var nomeParts  = nominativo.split(" - ");
    var nomeRaw    = nomeParts.length > 1 ? nomeParts.slice(1).join(" - ") : nominativo;
    var cfDisplay  = nomeParts.length > 1 ? nomeParts[0] : "";
    var nomeDisplay = nomeRaw.toLowerCase().replace(/\b\w/g, function(c) { return c.toUpperCase(); });

    var bodyRows = "";
    if (previewData.ambito) bodyRows += '<div class="bd-preview-row"><span class="bd-preview-key">Ambito</span><span class="bd-preview-val">' + previewData.ambito + '</span></div>';
    if (previewData.bene)   bodyRows += '<div class="bd-preview-row"><span class="bd-preview-key">Bene</span><span class="bd-preview-val">'   + previewData.bene   + '</span></div>';

    modalBody.innerHTML =
      STEPS_2 +
      '<div id="bd-preview-box">' +
        '<div class="bd-preview-header">' +
          '<div class="bd-preview-name">' + nomeDisplay + '</div>' +
          (cfDisplay ? '<div class="bd-preview-cf">' + cfDisplay + '</div>' : '') +
        '</div>' +
        (bodyRows ? '<div class="bd-preview-body">' + bodyRows + '</div>' : '') +
        '<div class="bd-preview-footer">' +
          '<span class="bd-preview-footer-label">Importo buono</span>' +
          '<span id="bd-preview-amount">&euro; ' + amount + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="bd-terms">' +
        '<div class="bd-terms-title">' + SVG_WARN + ' Termini e condizioni</div>' +
        '<ul class="bd-terms-list">' +
          '<li>Il voucher &egrave; <strong>monouso</strong>: viene consumato definitivamente al momento del riscatto.</li>' +
          '<li>Non &egrave; possibile ottenere il <strong>rimborso</strong> del voucher una volta riscattato.</li>' +
          '<li>Il codice sconto generato &egrave; valido <strong>solo per questo ordine</strong> e non cedibile.</li>' +
        '</ul>' +
        '<a class="bd-terms-link" href="/pages/come-utilizzare-il-bonus-docente" target="_blank">Leggi l\'informativa completa &rarr;</a>' +
      '</div>' +
      '<button id="bd-confirm-btn" type="button">' + SVG_CHECK + '<span class="bd-btn-text">Riscatta codice</span></button>' +
      '<button id="bd-cancel-link" type="button">Annulla</button>' +
      '<div id="bd-msg"></div>';

    document.getElementById("bd-confirm-btn").addEventListener("click", function () { showStep3(variantId, previewData); });
    document.getElementById("bd-cancel-link").addEventListener("click", closeProdModal);
  }

  /* ── Step 3: conferma definitiva prima del riscatto ── */
  function showStep3(variantId, previewData) {
    var modalBody = document.getElementById("bd-modal-body");
    if (!modalBody) return;
    var amount = Number(previewData.eligibleAmount || 0).toFixed(2);

    modalBody.innerHTML =
      '<div class="bd-final-warning">' +
        SVG_WARN_LG +
        '<h3>Conferma riscatto</h3>' +
        '<p>Stai per riscattare definitivamente il buono da <strong>&euro; ' + amount + '</strong>.<br>' +
        'Questa azione &egrave; <strong>irreversibile</strong>: il voucher verr&agrave; consumato e non potr&agrave; essere rimborsato.</p>' +
      '</div>' +
      '<label class="bd-checkbox-label" for="bd-agree-check">' +
        '<input type="checkbox" id="bd-agree-check">' +
        '<span>Ho letto i termini e confermo di voler riscattare il voucher, consapevole che non potr&agrave; essere rimborsato.</span>' +
      '</label>' +
      '<button id="bd-final-btn" type="button" disabled>' + SVG_CHECK + '<span class="bd-btn-text">Conferma e riscatta</span></button>' +
      '<button id="bd-cancel-link" type="button">Torna indietro</button>' +
      '<div id="bd-msg"></div>';

    var agreeCheck = document.getElementById("bd-agree-check");
    var finalBtn   = document.getElementById("bd-final-btn");
    agreeCheck.addEventListener("change", function () {
      finalBtn.disabled = !this.checked;
    });
    finalBtn.addEventListener("click", function () { submitStep2(variantId); });
    document.getElementById("bd-cancel-link").addEventListener("click", function () { showStep2(previewData, variantId); });
  }

  /* ── Riscatta voucher e vai al checkout ── */
  async function submitStep2(variantId) {
    if (!prodPreviewId) return;
    var btn = document.getElementById("bd-final-btn");
    btn.disabled = true;
    setBtnText(btn, "Elaborazione…");
    showMsg("", null);
    try {
      var res = await fetch(APP_URL + "/api/redeem-voucher", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ previewId: prodPreviewId, shop: shop, customerEmail: customerEmail, customerName: customerName }),
      });
      var data = await res.json();
      if (data.valid) {
        setBtnText(btn, "Aggiunta al carrello…");
        /* Pagine con più righe d'acquisto (es. Standard + Premium di Claude Team)
           espongono window.bdCartItems: senza, si aggiungerebbe una sola unità
           ignorando la selezione dell'utente e il minimo di postazioni. */
        var cartPayload = { id: Number(variantId), quantity: 1 };
        if (typeof window.bdCartItems === "function") {
          try {
            var items = window.bdCartItems();
            if (items && items.length) cartPayload = { items: items };
          } catch {}
        }
        var addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cartPayload),
        });
        if (!addRes.ok) {
          showMsg("Errore nell'aggiunta al carrello. Riprova.", false);
          btn.disabled = false;
          setBtnText(btn, "Conferma e riscatta");
          return;
        }
        setBtnText(btn, "Reindirizzamento…");
        window.location.href = "/checkout?discount=" + encodeURIComponent(data.discountCode);
      } else {
        showMsg(data.message || "Voucher non valido o già utilizzato.", false);
        btn.disabled = false;
        setBtnText(btn, "Conferma e riscatta");
      }
    } catch {
      showMsg("Errore di rete. Riprova.", false);
      btn.disabled = false;
      setBtnText(btn, "Conferma e vai al checkout");
    }
  }

  function showMsg(text, ok) {
    var el = document.getElementById("bd-msg");
    if (!el) return;
    el.textContent = text;
    el.className = "";
    el.style.display = text ? "block" : "none";
    if (ok === true)  el.classList.add("ok");
    if (ok === false) el.classList.add("err");
    if (ok === false && text) lastVoucherError = text;
  }

  /* ── Init ── */
  function init() {
    if (!isProduct || !dataEl) return;

    if (cdSospeso) {
      initSospesoNotice(CD_SOSPESO_MSG, { avvisami: true, regole: true });
      return;
    }

    /* Tetto annuo dell'esercente: lo decide il server (/api/cd-status). Se il
       limite e' raggiunto niente pulsante, solo il box informativo. In caso di
       errore di rete si prosegue: il rifiuto vero lo fanno comunque preview e
       redeem lato server. */
    fetch(APP_URL + "/api/cd-status?shop=" + encodeURIComponent(shop))
      .then(function (r) { return r.json(); })
      .then(function (st) {
        if (st && st.accetta === false) {
          /* Testo volutamente breve: la striscia deve restare su una riga.
             Il messaggio esteso del server resta per le risposte delle API. */
          initSospesoNotice(CD_SOSPESO_MSG, { avvisami: true, regole: true });
          return;
        }
        proseguiInit();
      })
      .catch(function () { proseguiInit(); });
  }

  function proseguiInit() {
    if (!suRichiesta) { initProductBtn(); return; }

    var token = getCdAuthToken();
    if (!token) { initRequestBtn(); return; }

    fetch(WORKER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cd_auth_check: token }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok) { initRequestBtn(); return; }
        if (!d.email) { initProductBtn(); return; } // passe-partout admin, comportamento attuale

        var pageHandle = window.location.pathname
          .split("/products/")[1]
          ? window.location.pathname.split("/products/")[1].split("/")[0]
          : "";

        if (d.handle !== pageHandle) {
          initRequestBtn();
          return;
        }

        var normalizedCustomerEmail = (customerEmail || "").trim().toLowerCase();
        var normalizedTokenEmail = (d.email || "").trim().toLowerCase();
        if (!normalizedCustomerEmail || normalizedCustomerEmail !== normalizedTokenEmail) {
          initLoginNotice(d.email);
          return;
        }

        initProductBtn();
      })
      .catch(function () { initRequestBtn(); });  // fail closed
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
